
import { prop, Vue } from "vue-class-component";

class Props {
  fill = prop<boolean>({
    default: false,
    type: Boolean,
  });
}
export default class Archive extends Vue.with(Props) {}
